//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

  export default {
    props: {
      isOpen: {
        type: Boolean,
        default: true
      },
      level1: {
        type: String,
        default: '浙粤京津沪鲁冀云辽黑湘皖新苏赣鄂桂甘晋蒙陕吉闽贵青藏川宁琼豫渝港澳'
      },
      level2_2: {
        type: String,
        default: '警学领港澳使挂'
      },
      level2: {
        type: String,
        default: '1234567890QWERTYUPASDFGHJKLZXCVBNM警学挂'
      },
      maxLength: {
        type: Number,
        default: 7
      },
      onChange: {
        type: Function,
        default: (onChangeFunc) => {
          onChangeFunc(this.inputValue)
        }
      },
      onBlur: {
        type: Function,
        default: () => {
        }
      },
      onDone: {
        type: Function,
        default: () => {
        }
      },
      defaultValue: {
        type: String,
        default: ''
      }
    },
    data () {
      return {
        winH: window.innerHeight,
        inputValue: this.defaultValue || ''
      }
    },
    watch: {
      defaultValue () {
        this.inputValue = this.defaultValue
      }
    },
    methods: {
      selectLevel1 (e, level1) {
        e.preventDefault()
        this.inputValue = level1
        this.onChange(level1)
      },
      selectLevel2 (e, level2) {
        e.preventDefault()
        const inputValue = this.inputValue + level2
        if (inputValue.length > this.maxLength) {
          this.onDone()
        } else {
          this.inputValue = inputValue
          this.onChange(inputValue)
        }
      },
      backspace () {
        const inputValue = this.inputValue
        const backspaceValue = inputValue.substr(0, inputValue.length - 1)
        this.inputValue = backspaceValue
        this.onChange(backspaceValue)
      }
    }
  }



// WEBPACK FOOTER //
// ./src/components/common/car-keyboard/index.vue